import { toast } from 'react-toastify';

import { useEventPreview } from './useEventPreview';
import { Event } from '../interfaces';

export type Action = 'approved' | 'saved' | 'rejected' | 'skipped' | 'warned';

export const useToaster = () => {
  const { openEventModal } = useEventPreview();

  const toastToSeePreviousEvent = (action: Action, event: Event, previousEvent: Event) => {
    if (previousEvent?.id) {
      toast.dismiss(previousEvent?.id);
    }
    if (event) {
      let toastEmitterFunc;

      switch (action) {
        case 'approved':
          toastEmitterFunc = toast.success;
          break;

        case 'saved':
          toastEmitterFunc = toast.info;
          break;

        case 'skipped':
          toastEmitterFunc = toast.dark;
          break;

        case 'rejected':
          toastEmitterFunc = toast.error;
          break;

        case 'warned':
          toastEmitterFunc = toast.warn;
          break;

        default:
          return;
      }

      toastEmitterFunc(`Event ${event.id} has been ${action}! Click to view`, {
        onClick: () => {
          openEventModal(event.id);
        },
        autoClose: 10000,
        position: 'top-center',
        toastId: event?.id,
      });
    }
  };

  return { toastToSeePreviousEvent };
};
